import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../App.css";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  const highlights1 = [
    "Township-Scale Living in Prime Kalwa-Thane Corridor",
    "Premium 2 & 3 BHK Residences by Birla Estates",
    "28 Acres of Gated Community with Multiple Towers",
  ];
  const highlights2 = [
    "Expansive Green Open Spaces & Modern Amenities",
    "Excellent Connectivity to Airoli, Thane & Navi Mumbai",
    "Developed by the Trusted Birla Group Legacy",
  ];

  return (
    <section className="section shadow-sm lazyloaded text-center" id="overview">
      <h1 className="d-block section-heading color-primary text-capitalize text-center">
        {project} - Overview
      </h1>

      <p className="overview-para">
        Presenting Birla Estates Kalwa, a landmark upcoming township by Birla
        Estates. Spread across 28 acres, this master-planned project, Birla
        Estates Kalwa in Thane, is poised to redefine urban living in the
        Kalwa-Airoli growth corridor. Thoughtfully envisioned with contemporary
        lifestyle needs, this residential enclave will offer spacious 2 & 3 BHK
        homes, surrounded by open greens and integrated conveniences.
        <br />
        The project Birla Estates Kalwa Thane brings Birla's legacy of trust,
        design excellence, and innovation to one of Navi Mumbai's most strategic
        locations. With seamless access to Airoli, Ghansoli, and Thane, and the
        promise of world-class amenities and thoughtful planning, Birla Estates
        Kalwa is set to become one of the most aspirational addresses in the
        region.
      </p>

      <center>
        <h3 className="mt-3" style={{ fontSize: "1.2rem" }}>
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        className="chat-btn btn btn-info micro-form-btn effetGradient enqModal download_brochure"
        data-form="md"
        data-title="Download Brochure"
        data-btn="Download Now"
        data-enquiry="Download Brochure Welcome Text"
        data-redirect="brochure"
        data-redirect-file="brochure.pdf"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("Overview - Download Brochure")}
      >
        <span className="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
